'use client'

export default function NewsletterForm() {
  return (
    <p className="text-xs theme-text-soft font-display font-bold uppercase tracking-widest">
      Newsletter — prossimamente
    </p>
  )
}
